import { Search, X } from "lucide-react";
import { Input } from "~/components/ui/input";
import { cn } from "~/lib/utils";

interface SearchInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  ariaLabel?: string;
  density?: "compact" | "comfortable";
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Search",
  className,
  ariaLabel,
  density = "compact",
}: SearchInputProps) {
  const roomy = density === "comfortable";
  return (
    <div className={cn("relative w-full", !roomy && "max-w-xs", className)}>
      <Search
        className={cn(
          "text-text-faint pointer-events-none absolute top-1/2 -translate-y-1/2",
          roomy ? "left-3.5 size-4.5" : "left-2.5 size-3.5",
        )}
        strokeWidth={1.75}
      />
      <Input
        type="search"
        density={density}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className={roomy ? "pr-12 pl-11" : "pr-7 pl-8"}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Clear search"
          className={cn(
            "text-text-faint hover:text-foreground absolute top-1/2 inline-flex -translate-y-1/2 items-center justify-center rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40",
            roomy ? "right-0.5 size-11" : "right-1.5 size-5",
          )}
        >
          <X className={roomy ? "size-4" : "size-3"} strokeWidth={2} />
        </button>
      )}
    </div>
  );
}
